/* eslint-disable no-shadow */
import useSWR from 'swr';

import { fetchModelStatus } from 'src/store/api';

function fetcher(modelIds, query, options) {
  if (!modelIds.length) {
    return undefined;
  }
  return Promise.all(modelIds.map((id) => fetchModelStatus(id, query, options)));
}

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnMount: false,
  revalidateOnFocus: false,
};

export default function useModelsStatus({ modelIds, query = {}, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const base = '/core/v2/thinkalike_model/:id/status';
  const urls = [base, ...modelIds.sort().map((modelId) => base.replace(':id', modelId))];

  const { fields = '*', ...requestQuery } = { fields: '*', ...query };
  const requestOptions = {
    headers: {
      'X-Fields': fields,
    },
    ...options,
  };

  return useSWR(
    shouldFetch ? { key: urls, modelIds, requestQuery, requestOptions } : null,
    ({ modelIds: m, requestQuery: q, requestOptions: o }) => fetcher(m, q, o),
    swrConfig
  );
}
